<template>
    <div>
      <div class="circleParent">
         <div class="circleWithIcon text-xs-center">
            <v-container fluid fill-height>
              <v-layout align-center justify-center>
                <v-flex xs12 sm12 md12>
                  <img height="40px" src="@/assets/check.png" alt="">
                </v-flex>
              </v-layout>
            </v-container>
         </div>
        <v-card class="text-xs-center  pa-3 pt-5" >
          <div class="display-2 secondary--text text--darken-4">
            {{$t('feedback.message.success')}}
          </div>
          <div class=" pt-2 subheading secondary--text">{{message}}</div>
        </v-card>
       </div>

    </div>
</template>
<script>
export default {
    name: "FeedbackMessage",
    props: {
      type: {
        type: String,
        default:null
      },
      message: {
        type: String,
        default: null
      }
    }
}
</script>
<style scoped>
.circleWithIcon {
      background: #6DCD01;
      width: 100px;   /* circle diameter */
      height: 100px;   /* circle diameter */
      border-radius: 50%;
      position: absolute;
      top: 0;
      left: 50%;
      margin: -50px 0 0 -50px; /* minus circle radius */
      z-index: 1;
  }

  .circleParent {
    background: white;
    width: 100%;
    margin-top: 50px;   /* circle radius */
    position: relative;
  }
</style>
